import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'app/dashboard/dashboard.service';

@Component({
  selector: 'app-whatsapp-message',
  templateUrl: './whatsapp-message.component.html',
  styleUrls: ['./whatsapp-message.component.scss']
})
export class WhatsappMessageComponent implements OnInit {
  mobilenumber:any;
  message:any;
  postId:any;
  countrycode:any;
  constructor( public dashboardService: DashboardService,private http: HttpClient) { }

  ngOnInit(): void {
    this.onCountryChange(91);
  }
    
  onCountryChange(event:any){
   
    if(event.dialCode!=null || event.dialCode !=undefined){
      this.countrycode=event.dialCode;
    }else{
      this.countrycode=91;
    }
   
   console.log(event);
  }
  validateuser(){
    const codemobilenumber=this.countrycode+this.mobilenumber;
    var token='65cf5917-6a10-11ec-8286-0645430715b9';
    if(this.mobilenumber!=null && this.message !=null && this.message!= "" && this.mobilenumber!= ""){
      const body = {
        "appid": "a_157354522561438800",
        "deliverychannel": "whatsapp",
        "message": {
            "template": "1272404983119428",
            "parameters": {
                "variable1": this.message,
                "variable2": "SRN9492294"
            }
        },
        "destination": [
            {
                "waid": [
                  codemobilenumber
                ]
            }
        ]
    };
    
      this.dashboardService.getWhatsapp(body).subscribe(
        data => this.successSend(data), err => this.failedMessage(err) )
    }else{
      this.dashboardService.openSnackBar("Please Enter Input Field", "OK");
    }
  }

  successSend(data){
    this.dashboardService.openSnackBar("Message send Successfully", "OK");
    this.cleardata();
  }
  failedMessage(err){
    this.dashboardService.openSnackBar("Message Failed", "OK");
  }
  cleardata(){
   this.mobilenumber=null;
   this.message=null;
  }
}
